module.exports = "/images/hotmail.png?caa19ec9d2ba70848dc1ce27bd599d9f";